var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMinify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.15256e-07C5.37097 7.15256e-07 7.15256e-07 5.37097 7.15256e-07 12C7.15256e-07 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 7.15256e-07 12 7.15256e-07ZM12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774ZM11.0323 5.80645H12.9677C13.2871 5.80645 13.5484 6.06774 13.5484 6.3871V12L16.7903 12C17.3081 12 17.5645 12.6242 17.2016 12.9919L12.4113 17.7823C12.1839 18.0097 11.8161 18.0097 11.5887 17.7823L6.79839 12.9919C6.43065 12.6242 6.69194 12 7.20968 12H10.4516V6.3871C10.4516 6.06774 10.7129 5.80645 11.0323 5.80645Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinify);
export default __webpack_public_path__ + "static/media/icon-minify.0470ffb9b1d6c604e3dcfe7bd3e84a7d.svg";
export { ForwardRef as ReactComponent };